import { I18n } from "@assets/strings";
import React from "react";
import { theme } from "@ui/styles/theme";

type TypeFormat = "image" | "pdf" | "video" | "document";
interface FileReminderInfoProps extends React.HTMLAttributes<HTMLDivElement> {
	fileSize: number;
	acceptedFormat: TypeFormat;
}

export const FileReminderInfo: React.FC<FileReminderInfoProps> = ({ fileSize, acceptedFormat, ...htmlProps }) => {
	return (
		<div style={{ fontSize: "12px", fontWeight: 600 }} {...htmlProps}>
			<span style={{ color: theme.colors.primary }}>{I18n.t("application.form.reminder")} : </span>
			{I18n.t(`application.form.upload_file.requirement`, { fileSize }).concat(
				" : ",
				acceptedFormat === "document"
					? ".png, .jpg, .jpeg, .pdf"
					: acceptedFormat === "image"
						? ".png, .jpg, .jpeg"
						: acceptedFormat === "pdf"
							? ".pdf"
							: ".mp4, .avi"
			)}
		</div>
	);
};
